import { useEffect, useState } from "react";
import { fetchItemTypes, downloadItemTypesExcel } from "../Api/ViewItemTypes";
import { Container, Table, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment";

const ViewItemTypes = () => {
  const [itemTypes, setItemTypes] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const loadItemTypes = async () => {
      try {
        const data = await fetchItemTypes();
        setItemTypes(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching Item Types`);
      }
    };

    loadItemTypes();
  }, []);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await downloadItemTypesExcel();
      
      if (!response.data) {
        throw new Error("No data received from server");
      }
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'ItemTypes_Data.xlsx');
      
      // Trigger download
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
      }, 100);
      
      toast.success("Item Types data download started!");
    } catch (error) {
      console.error("Download error:", error);
      toast.error(`🦄 Download failed: ${error.message}`);
    } finally {
      setIsDownloading(false);
    }
  };

  const handleCreateItemType = () => {
    navigate("/itemTypeMaster");
  };

  return (
    <>
      <div>
        <Container className="list-container">
          <div className="header-background">
            <h2 className="header-list-title">View Item Types</h2>
            <div>
              <Button 
                style={{
                  marginBottom:'2px'
                }}
                variant="success" 
                onClick={handleCreateItemType}
                className="gradient-btn green-btn"
              >
                Add Item Type
              </Button>
              <Button 
                variant="primary" 
                className="gradient-btn"
                onClick={handleDownload}
                disabled={isDownloading || itemTypes.length === 0}
              >
                {isDownloading ? 'Downloading...' : 'Download Data'}
              </Button>
            </div>
          </div>

          {itemTypes.length > 0 ? (
            <Table bordered hover responsive className="data-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Code</th>
                  <th>Description</th>
                  <th>Created On</th>
                  <th>Created By</th>
                  <th>Changed On</th>
                  <th>Changed By</th>
                </tr>
              </thead>
              <tbody>
                {itemTypes.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.code}</td>
                    <td>{item.description}</td>
                    <td>
                      {moment(item.createdOnDate).format('L')} at {item.createdOnTime?.substring(0, 8)}
                    </td>
                    <td>{item.createdBy}</td>
                    <td>
                      {item.changedOnDate ? 
                        `${moment(item.changedOnDate).format('L')} at ${item.changedOnTime?.substring(0, 8)}` 
                        : 'N/A'}
                    </td>
                    <td>{item.changedBy || 'N/A'}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <p className="no-data">No item types found.</p>
          )}
        </Container>
      </div>
    </>
  );
};

export default ViewItemTypes;